import ShippingAPIS from '@/services/shippingapis.service'
import Utils from '../common/utils'
import store from '@/globalvar'

var parseString = require('xml2js').parseString;

const ExternalAPI = {

    async getCityStateByZipCode(ZipCode) {
        if (!isNaN(parseInt(ZipCode)) && isFinite(ZipCode)) {
            const useZipCodeApi = store.state.companies.UseZipCodeApi;
            const zipCodeApiurl = store.state.companies.ZipCodeApiurl;
            const zipCodeApiuser = store.state.companies.ZipCodeApiuser;
            let shippingData = [];
            ZipCode = ZipCode.slice(0,5);

            if (useZipCodeApi == 'Y') {
                    await ShippingAPIS.getCityStateLookup(ZipCode,zipCodeApiurl,zipCodeApiuser)
                        .then((response) => {
                          const shippingDataXML = response.data;
                          parseString(shippingDataXML, function (err, result) {
                            const shippingDataJSON = result ;
                            if (shippingDataJSON.CityStateLookupResponse.ZipCode[0].City != undefined) {
                              shippingData.City = Utils.strToTitleCase(shippingDataJSON.CityStateLookupResponse.ZipCode[0].City[0]);
                              shippingData.State= shippingDataJSON.CityStateLookupResponse.ZipCode[0].State[0];
                            }
                          })
                        })
                        .catch(() => {
                           
                        });
                }
        return shippingData;
        }
    },
}

export default ExternalAPI;